module.exports = __webpack_public_path__ + "img/mobile.be5c1ec9.png";